<div>
    <div class="row m-0 border-bottom px-3 es-py justify-content-between">
    <h1 mat-dialog-title class="mb-0 d-flex align-items-center">Solar News & Updates</h1>
    <button mat-icon-button mat-dialog-close type="button" (click)="onCloseClick()">
      <mat-icon>clear</mat-icon>
    </button>
    </div>
    <div mat-dialog-content class="row m-0 p-5 mx-2">
        <mat-accordion class="w-100">
            <!-- <mat-expansion-panel class="mb-2" [expanded]="expandPanel === 1" (opened)="panelOpenState = true"
                                 (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title class="align-items-center">
                  <span class="material-icons-outlined">insert_drive_file</span> 
                  <span class="ml-2 mt-1">Welcome to the Supplier Gateway</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row mx-0 pt-3">
                  <p>
                    Welcome to Solar Turbines’ new Supplier Gateway!  You can now:
                  </p>
                  <div>
                    <ul>
                      <li>
                        Directly access and download our commonly used forms from the “Solar Forms” Tab
                      </li>
                      <li>
                        Upload and download files by clicking the “My Document” button from the Homepage or the “Documents” Tab
                      </li>
                      <li>
                        Can still access the same documents and links you previously could from the old Supplier Gateway
                      </li>
                      <li>
                        Please reach out to your Solar contact if you would like additional training or have any questions on how to use the gateway
                      </li>
                    </ul>
                  </div>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel class="mb-2" [expanded]="expandPanel === 2" (opened)="panelOpenState = true"
                                 (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title class="align-items-center">
                  <span class="material-icons-outlined">insert_invitation</span>
                  <span class="ml-2 mt-1">Solar Holidays: Coming Soon</span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row mx-0 pt-3">
                  <div>
                    <p>
                      Please reach out to your Buyer to receive the schedule for our Receiving Dock for the upcoming Holiday Season.
                    </p>
                  </div>
              </div>
            </mat-expansion-panel> -->
           
            <ng-container *ngFor="let item of pageContentsDetails; index as i">    

            <mat-expansion-panel  class="mb-2" [expanded]="expandPanel === i+3 " (opened)="panelOpenState = true"
                                 (closed)="panelOpenState = false">
              <mat-expansion-panel-header>
                <mat-panel-title class="align-items-center">
                  <!-- <span class="material-icons-outlined">insert_invitation</span> -->
                  <p class="mb-0" *ngIf="item.type == 'Policy'" [ngClass]="item.highImportance == true || item.isUrgent == true ? 'sg-priority-marker' : ''">
                    <span class="material-icons-outlined">
                      privacy_tip
                    </span>
                  </p>
                  <p class="mb-0" *ngIf="item.type == 'Document'" [ngClass]="item.highImportance == true || item.isUrgent == true ? 'sg-priority-marker' : ''">
                    <span class="material-icons-outlined">description</span>
                  </p>
                  <p class="mb-0" *ngIf="item.type == 'Date'" [ngClass]="item.highImportance == true || item.isUrgent == true ? 'sg-priority-marker' : ''">
                    <span class="material-icons-outlined">
                      event
                    </span>
                  </p>
                  <span class="ml-2 mt-1"> {{item.sectionHeader}} </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="row mx-0 pt-3">
                  <div>
                    <p>  {{item.sectionDescription}} </p>
                  </div>
              </div>
              <div class="row mx-0 pt-2">
                <div>
                    <p class="sg-read-more mb-1" *ngFor="let links of item.links">
                      <a *ngIf="links.linkType == 'Document'" target="_blank" (click)="downloadDocument(links.linkAddress, 'View', links.linkType)">{{links.linkTitle}}</a>
                      <a [href]="links.linkAddress" target="_blank" *ngIf="links.linkType == 'URL'">{{links.linkTitle}}</a>
                    </p>
                </div>
            </div>
            </mat-expansion-panel>
          </ng-container>
        </mat-accordion>
        
    </div>
  
    <div mat-dialog-actions class="row m-0 d-flex es-py justify-content-end border-top">
      <div class="col-2 d-flex justify-content-end">
        <button mat-raised-button class="mat-primary mat-raised-button sg-primary-button w-75" (click)="onOkClick()">Ok</button>
      </div>
    </div>
</div>